import { render, staticRenderFns } from "./SubscriptionSidebar.vue?vue&type=template&id=40a9ee0c&scoped=true&"
import script from "./SubscriptionSidebar.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionSidebar.vue?vue&type=style&index=0&id=40a9ee0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9ee0c",
  null
  
)

export default component.exports